/**
 * Role constants for the application
 * These should match the role slugs in the database
 */
class Roles {
  static readonly Admin: string = 'admin';
  static readonly User: string = 'user';
  static readonly Employee: string = 'employee';
}

export default Roles;
